module.exports = "/static/assets/36770e433b22fecc706efd99c78bcd44.png";